
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"buliding","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M2 22h20","fill":"#292d32"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17 2H7C4 2 3 3.79 3 6v16h18V6c0-2.21-1-4-4-4zM7 16.5h3M14 16.5h3M7 12h3M14 12h3M7 7.5h3M14 7.5h3","fill":"none"}})])])
          )
        }
      }
    